var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { GET_TRUSTEES_NAMES } from "@/queries/GetTrusteesNames";
import { useQuery } from "@apollo/client";
import { InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
var SelectActedTrustee = function (_a) {
    var _b;
    var tenantId = _a.tenantId, onSelectTrustee = _a.onSelectTrustee, defaultValue = _a.defaultValue, label = _a.label;
    var _c = useState(""), value = _c[0], setValue = _c[1];
    var trustees = useQuery(GET_TRUSTEES_NAMES, {
        variables: {
            tenantId: tenantId,
        },
    }).data;
    useEffect(function () {
        var _a;
        if (defaultValue) {
            var trustee = trustees === null || trustees === void 0 ? void 0 : trustees.sequent_backend_trustee.find(function (trustee) { return trustee.name === defaultValue; });
            handleChangeTrustee === null || handleChangeTrustee === void 0 ? void 0 : handleChangeTrustee((_a = trustee === null || trustee === void 0 ? void 0 : trustee.name) !== null && _a !== void 0 ? _a : "");
        }
    }, [trustees, defaultValue]);
    var handleChangeTrustee = function (v) {
        onSelectTrustee(v);
        setValue(v);
    };
    return (_jsxs(_Fragment, { children: [label && _jsx(InputLabel, __assign({ id: "select-label" }, { children: label })), _jsxs(Select, __assign({ name: "Acted trustee", labelId: "trustee", label: label, value: value, onChange: function (e) { return handleChangeTrustee(e.target.value); } }, { children: [_jsx(MenuItem, __assign({ value: " " }, { children: " " }), "empty-value"), (_b = trustees === null || trustees === void 0 ? void 0 : trustees.sequent_backend_trustee) === null || _b === void 0 ? void 0 : _b.map(function (trustee) {
                        return (_jsx(MenuItem, __assign({ value: trustee.name }, { children: trustee.name }), trustee.id));
                    })] }))] }));
};
export default SelectActedTrustee;
